import Vue from "vue";
import Router from "vue-router";
import ToastService from "../service/toastService";
import Saisie from "../pages/Saisie";
import Accueil from "../pages/Accueil";
import PageIntrouvable from "../pages/errors/404";
import Adherent from "../pages/Adherent";
import Projet from "../pages/Projet";
import Referentiels from "../pages/Referentiels";
import RecusFiscaux from "../pages/RecusFiscaux";
import AuthService from "@/service/authService";
import Login from "@/pages/Login.vue";
import Verify from "@/pages/Verify.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Accueil",
      component: Accueil,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        layout: "login-layout",
      },
    },
    {
      path: "/verify",
      name: "Verify",
      component: Verify,
      meta: {
        layout: "login-layout",
      },
    },
    {
      path: "*",
      name: "PageIntrouvable",
      component: PageIntrouvable,
    },

    {
      path: "/saisie",
      name: "Saisie",
      component: Saisie,
    },
    {
      path: "/adherent",
      name: "Adherent",
      component: Adherent,
    },
    {
      path: "/projet",
      name: "Projet",
      component: Projet,
    },
    {
      path: "/referentiels",
      name: "Referentiels",
      component: Referentiels,
    },
    {
      path: "/recus-fiscaux",
      name: "RecusFiscaux",
      component: RecusFiscaux,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.path === "/login" || to.path === "/verify") {
    next();
    return;
  }

  if (AuthService.isAuthenticated()) {
    next();
    return;
  }

  AuthService.fetchUser()
    .then(() => {
      next();
    })
    .catch(() => {
      if (to.path !== "/") {
        ToastService.displayErrorToast(
          "Vous devez être authentifié pour accéder à cette page"
        );
      }
      next("/login");
    });
});

export default router;
